import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import Project from './Project';
import Footer from './Footer';
import Introduction from './Introduction';
import Hills from './Hills';
import Sun from './Sun';
import Stars from './Stars';
import ProjectsContainer from './ProjectsContainer';
import '../styles/parallax.scss'
import '../styles/main.scss'


export default class App extends Component {
  render() {
    return (
      <div className="main-app-container parallax">
        <div className="parallax__group parallax__background">
          <div className="parallax__layer parallax__layer--base">
            <Stars />
          </div>
          <div className="parallax__layer parallax__layer--back-1">
            <Stars />
          </div>
          <div className="parallax__layer parallax__layer--back-2">
            <Stars />
          </div>       
        </div>
        <div className="parallax__group">
          <div className="parallax__layer parallax__layer--base">
            <Introduction />
          </div>
          <div className="parallax__layer parallax__layer--back-2">
            <Sun />
          </div>
        </div>
        <div className="parallax__group">
          <div className="introtext">
            I make webpages. If you can imagine it, then I can solve it on the web.  <br />
            Below, you can find some website samples that showcase the web technologies I have experience with.<br />
          </div>
          <ProjectsContainer />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js